export function coordText(location) {
  if (!location) return '';
  const { lat, lng } = location;
  if (typeof lat !== 'number' || typeof lng !== 'number') return '';
  return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
}

/**
 * The Work Review LOCATION panel's status badge: [toneClasses, label].
 *
 * `locationChangeStatus` reads `'none'` in TWO different real situations: a
 * location that has genuinely never been touched since order creation, AND
 * an order whose worker GPS correction already applied directly
 * (`correctGraveLocation` clears any legacy pending/approve request back to
 * `'none'` once a correction lands, since that flow has no customer-approval
 * step -- see functions/index.js). So `'none'` alone is never proof nothing
 * changed. When status is `'none'`, this also compares the actual
 * `originalGraveLocation` snapshot against the current `graveLocation` to
 * tell those two cases apart. Every other status (`pending`/`approved`/
 * `rejected`/`admin_override`) is the legacy propose/approve flow and is
 * rendered exactly as it always was, unconditionally -- an applied direct
 * correction must never masquerade as one of those pending/resolved states.
 *
 * @param {object} order Firestore order data.
 * @return {[string, string]}
 */
export function locationChangeBadge(order) {
  const data = order || {};
  const status = data.locationChangeStatus || 'none';
  if (status !== 'none') {
    return {
      pending: ['bg-amber-100 text-amber-700', 'Proposed'],
      approved: ['bg-green-100 text-green-700', 'Accepted'],
      rejected: ['bg-red-100 text-red-700', 'Rejected'],
      admin_override: ['bg-purple-100 text-purple-700', 'Admin override'],
    }[status] || ['bg-gray-100 text-gray-500', status];
  }
  const snapshot = data.originalGraveLocation;
  const hasSnapshot = Boolean(snapshot) && typeof snapshot === 'object';
  if (hasSnapshot && coordText(snapshot) !== coordText(data.graveLocation)) {
    return ['bg-blue-100 text-blue-700', 'Corrected'];
  }
  return ['bg-gray-100 text-gray-500', 'No change'];
}
